import { FC, MouseEventHandler } from "react";
import { Plus, UserPlus, RefreshCw } from "lucide-react";

import { Restricted } from "../../Restricted";
import { Button } from "../../../ui/layout/molecules/Button";

import { MEDIUM_ICON_SIZE_STYLES } from "../../../ui/styles";

const ICON_STYLE = `${MEDIUM_ICON_SIZE_STYLES} sm:mr-2`;

const Icons = {
  new: <Plus className={ICON_STYLE} />,
  newUser: <UserPlus className={ICON_STYLE} />,
  refresh: <RefreshCw className={ICON_STYLE} />,
};

export type ToggleModalButtonProps = {
  createPermissions: string;
  buttonTitle: string;
  iconType: keyof typeof Icons;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const ToggleModalButton: FC<ToggleModalButtonProps> = ({
  createPermissions,
  buttonTitle,
  iconType,
  onClick,
}) => {
  return (
    <Restricted permissions={createPermissions}>
      <div className="flex items-center">
        <Button title={buttonTitle} buttonType="primary" onClick={onClick}>
          {Icons[iconType]}
        </Button>
      </div>
    </Restricted>
  );
};
